import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "./Layout.scss";
import { getFromStorage, removeFromStorage, STORAGE_KEYS } from "../helpers";
import { useLazyGetProfileQuery } from "../service/auth";
import { setCredentials } from "../reducers/authSlice";
import { useAppDispatch } from "../hooks/store";
import useAuth from "../hooks/useAuth";
import { useLazyGetNotificationsQuery } from "../service/notification";
import { NotificationType } from "../types/General";
import { showError } from "../constants/toasts";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { NOTIFICATION_TYPE } from "../utils/enums";
import { startSignalRConnection } from "../utils/socket";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const [getNotifications] = useLazyGetNotificationsQuery();
  const [hasFetched, setHasFetched] = useState(false);
  const [notificationData, setNotificationData] = useState<NotificationType[]>(
    []
  );
  dayjs.extend(relativeTime);
  const userData = useAuth();
  const [getUser] = useLazyGetProfileQuery();
  const dispatch = useAppDispatch();
  const [user, setUser] = useState(null) as any;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  useEffect(() => {}, [userData?.userId]);

  const getUserDetails = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);
    const data = (await getFromStorage(STORAGE_KEYS.userData)) ?? "{}";

    const parsedData = JSON.parse(data);

    if (token) {
      try {
        const result = await getUser({ id: parsedData?.userId || "" }).unwrap();
        if (result?.status === 200 && token) {
          setUser(result?.data || null);
          dispatch(
            setCredentials({
              user: result?.data?.userdata,
              token: token,
            })
          );
        }
      } catch (error) {
        console.error(error);
      }
    } else {
    }
  };

  const handleLogout = () => {
    removeFromStorage(STORAGE_KEYS.token);
    removeFromStorage(STORAGE_KEYS.offerData);
    dispatch(
      setCredentials({
        user: null,
        token: null,
      })
    );
    navigate("/");
  };

  const getNotificationApi = async () => {
    setLoading(true);
    try {
      const response = await getNotifications({
        search: "",
        page: 1,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setNotificationData(response?.data?.items || []);
      } else {
        setNotificationData([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getUserDetails();
    getNotificationApi();
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left"></div>
          <div className="topbar_right">
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/notification_icon.svg" alt="icon" />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 20,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => navigate("/recieved-notifications")}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  {notificationData?.slice(0, 3)?.map((item) => {
                    return (
                      <li key={item?.id}>
                        {/* <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt=""
                          />
                        </figure> */}
                        <div
                          className="noti_info"
                          onClick={() => {
                            if (
                              item?.notificationType ===
                              NOTIFICATION_TYPE.BOOKING
                            ) {
                              navigate(`/manage-booking-resvp`);
                            } else if (
                              item?.notificationType ===
                              NOTIFICATION_TYPE.PAYMENT
                            ) {
                              navigate(`/transactions`);
                            } else if (
                              item?.notificationType ===
                              NOTIFICATION_TYPE.ACCOUNT
                            ) {
                              navigate(`/manage-customers`);
                            }
                          }}
                        >
                          <Typography component="h3">
                            {item?.title || "-"}
                            <Typography component="span">
                              {dayjs(item?.createdAt).fromNow()}
                            </Typography>
                          </Typography>
                          <Typography component="p">
                            {item?.body || "-"}
                          </Typography>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </Menu>
            </Box>

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={
                    userData?.profileImage
                      ? userData?.profileImage
                      : "/static/images/user_placeholder.png"
                  }
                  alt="profile"
                  className="main_img"
                />
                <span>
                  {`${userData?.name || ""} `}
                  <img src="/static/images/down_arrow.svg" alt="icon" />{" "}
                </span>
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 15,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  My Profile
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile/change-password")}
                >
                  <IconButton className="drpdwn_icns">
                    <LockIcon />
                  </IconButton>
                  Change Password
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={handleLogout}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Topbar;
